module.exports = __webpack_public_path__ + "static/rubber_roughness_256-acdb332aad12d2784c4cffbed0654190.jpg";